import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import { getPaymentInfo } from "../../services/qr";

const OrderSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const orderIdFromQuery = query.get("orderId") || query.get("orderCode");
  const orderIdFromState = location.state?.orderId;
  const orderId = orderIdFromState || orderIdFromQuery;

  const [paymentStatus, setPaymentStatus] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleOrderSuccess = async () => {
      if (!orderId) {
        setPaymentStatus(t("order_not_found"));
        setLoading(false);
        return;
      }

      try {
        const data = await getPaymentInfo(orderId);
        if (data.status === "PAID") {
          setPaymentStatus(t("payment_success")); // "Thanh toán thành công"
          setTotalAmount(data.amount);
        } else {
          setPaymentStatus(t("payment_pending")); // "Chưa thanh toán"
        }
      } catch (error) {
        console.error("Error checking payment info:", error);
        setPaymentStatus(t("payment_error")); // "Có lỗi xảy ra khi kiểm tra thanh toán"
      } finally {
        localStorage.removeItem("checkoutForm"); // Clear luôn form
        setLoading(false);
      }
    };

    handleOrderSuccess();
  }, [orderId, t]);

  return (
    <Fragment>
      <SEO
        titleTemplate={t("order_success")}
        description={t("order_success_description")}
      />
      <LayoutOne headerTop="visible">
        <div className="order-success-area pt-100 pb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="order-success-content text-center">
                    <>
                      <div className="order-success-icon mb-45">
                        <i
                          className="pe-7s-check text-success"
                          style={{ fontSize: "100px" }}
                        ></i>
                      </div>
                      <h2 className="mb-4">{t("thank_you_order")}</h2>
                      <div className="order-success-btn">
                        <Link
                          to={process.env.PUBLIC_URL + "/shop-grid-standard"}
                          className="btn btn-fill-out btn-block mt-3"
                        >
                          {t("continue_shopping")}
                        </Link>

                        {orderId && (
                          <Link
                            to={process.env.PUBLIC_URL + `/account/orders/${orderId}`}
                            className="btn btn-fill-line btn-block mt-3"
                          >
                            {t("view_orders")}
                          </Link>
                        )}
                      </div>
                    </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default OrderSuccess;
